import React, { useEffect } from 'react';
import Principal from "../Principal/Principal";
import RecorridoHome from '../RecorridoHome/RecorridoHome';
import CasasVelasurBanner from '../Banner/CasasVelasurBanner';
import ConceptoVideo from "../ConceptoVideo/ConceptoVideo";
import Concepto from "../Concepto/Concepto";
import Disponibilidad from "../Disponibilidad/Disponibilidad";
import Ubicacion from "../ubicacion/Ubicacion";
import Slider from "../Slider/Slider";
import { SwiperSlide } from "swiper/react";
import { animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import { useNavigate, useLocation } from 'react-router-dom';
import './Home.scss';
import { useTranslation, Trans } from 'react-i18next';

const Home1 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const actualUrl = useLocation();

  const scrollTarget = (target) => { 
    scroller.scrollTo(target, {smooth: true, duration: 700});
  };
  
  const scrollToPage =  (target) => {
    navigate(`/${target}`);
    scrollTarget(target.slice(1));
  };

  useEffect(()=>{
    scrollToPage(actualUrl.hash);
  },[]);

  return(
    <>
      <div>
        <Principal/>
        <ConceptoVideo/>
        <Concepto
          titulo1={t('home1.community')}
          titulo2={t('home1.residential')}
        >
          <p>
            <Trans i18nKey="home1.description" components={{ bold: <strong /> }} />
          </p>
        </Concepto>
        <RecorridoHome/>
        <Disponibilidad/>
        <CasasVelasurBanner/>
        <Ubicacion/>
      </div>
    </>
  );
}

export default Home1;
